import * as React from "react"
import { Box } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { rrspFormFilters } from "../../@signals"


export default function actionsColumn(onRemove) {
    return {
        name: '', label: 'Actions',
        options: {
            headerAlign: 'center',
            filter: false,
            sort: false,
            customBodyRowRenderLite: (_, row) => <Box display="flex" justifyContent="center" gap={3}>
                <IconSeeker
                    icon="pen"
                    tooltip="Modify this RRSP row"
                    sx={{ fontSize: '1rem', cursor: 'pointer' }}
                    onClick={() => rrspFormFilters.value = { ...row }}
                />
                <IconSeeker
                    icon="trash"
                    tooltip="Delete this RRSP row"
                    sx={{ fontSize: '1rem', cursor: 'pointer' }}
                    onClick={() => onRemove(row)}
                />
            </Box>
        }
    }
}
